export default "__VITE_ASSET__tQi01jJN__"